import React from 'react';

interface SchemaCoverageProps {
  types: string[];
}

const SUGGESTED = [
  'Organization',
  'WebSite',
  'WebPage',
  'BreadcrumbList',
  'Article',
  'FAQPage',
];

export const SchemaCoverage: React.FC<SchemaCoverageProps> = ({ types }) => {
  if (!types.length) {
    return (
      <div>
        <p className="meta" style={{ margin: 0, marginBottom: 12 }}>
          No JSON-LD structured data detected. Consider adding common types:
        </p>
        <div className="schema-grid">
          {SUGGESTED.map((t) => (
            <span key={t} className="schema-chip" style={{ opacity: 0.55 }}>
              <span className="schema-chip-dot" style={{ background: 'var(--ink-4)' }} />
              {t}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="schema-grid">
      {types.map((t, idx) => (
        <span key={`${t}-${idx}`} className="schema-chip">
          <span className="schema-chip-dot" />
          {t}
        </span>
      ))}
    </div>
  );
};
